(function ($) {
  "use strict";

  jQuery(document).ready(function ($) {
    var date = new Date();
    var tomorrow = new Date();
    tomorrow.setDate(date.getDate() + 1);

    var startdatepicker = $("#startDate");
    startdatepicker.datepicker();
    startdatepicker.datepicker("setDate", date);

    var enddatepicker = $("#endDate");
    enddatepicker.datepicker();
    enddatepicker.datepicker("setDate", tomorrow);

    $(".datepicker").datepicker();

    var data = {
      action: "adjust_query",
      security: ZaBookDirect.security,
    };

    function getDate() {
      var startDate = $("#startDate").datepicker("getDate");
      var startDate = $.datepicker.formatDate("yy-mm-dd", startDate);
      var endDate = $("#endDate").datepicker("getDate");
      var endDate = $.datepicker.formatDate("yy-mm-dd", endDate);
      if (startDate != "" && endDate != "") {
        data["start_date"] = startDate;
        data["end_date"] = endDate;
      }
    }

    $(".c-booking-widget__views input").change(function () {
      var view = $(this).attr("id");
      if (view === "all-listings") {
        if (this.checked) {
          $("#available-listings").prop("checked", false);
          $(".c-booking-widget__dates").hide();
          data["view"] = "all-listings";
        } else {
          $("#available-listings").prop("checked", true);
          $(".c-booking-widget__dates").show();
          data["view"] = "available-listings";
        }
      } else if (view === "available-listings") {
        if (this.checked) {
          $("#all-listings").prop("checked", false);
          $(".c-booking-widget__dates").show();
          data["view"] = "available-listings";
        } else {
          $("#all-listings").prop("checked", true);
          $(".c-booking-widget__dates").hide();
          data["view"] = "all-listings";
        }
      }
      runAjax();
    });

    $(".c-booking-widget__checkbox input").change(function () {
      var termId = $(this).attr("value");
      var termType = $(this).attr("data-tax-type");
      if (this.checked) {
        if (!bookingTerms[termType]) {
          bookingTerms[termType] = [];
        }
        bookingTerms[termType].push(termId);
      }
      if (!this.checked) {
        bookingTerms[termType].splice(
          $.inArray(termId, bookingTerms[termType]),
          1
        );
      }

      runAjax(); // run query on category cahnge

      if ($(this).parent().hasClass("parent-term")) {
        $(this).parent().parent().find(".child-term").show();
      }
    });

    // run query on load more
    $("#seeMoreBookings").on("click", function () {
      $("#seeMoreBookings").html("loading...");
      bookingPostsNum += 10;
      console.log(bookingPostsNum);
      data["posts_num"] = bookingPostsNum;
      var loading = "loading";
      runAjax(loading);
    });

    // run query on date change
    $(".datepicker").change(function () {
      runAjax();
    });

    // run query on page load
    runAjax();

    // run ajax
    function runAjax(loading) {
      $(".c-booking-widget").addClass("thinking");
      getDate();
      data["term_ids"] = JSON.stringify([bookingTerms]);
      $.post(ZaBookDirect.ajaxurl, data, function (response) {
        $("#listings-browse-list").html(response);
        if (loading == "loading") {
          $("#seeMoreBookings").html("Load More");
        }
        $("#seeMoreBookings").show();
        $(".c-booking-widget").removeClass("thinking");
      });
    }

    // run query on search
    $(".c-search__button").on("click", function (e) {
      e.preventDefault();
      data["search_term"] = $("#c-booking-widget__search").val();
      runAjax();
    });
    $("#c-booking-widget__search").on("search", function (e) {
      // on search clear
      e.preventDefault();
      data["search_term"] = $("#c-booking-widget__search").val();
      runAjax();
    });
  });
})(jQuery);
